import type { WidgetId, WidgetType } from '../../widgetManager';

/**
 * Generate a unique widget ID
 */
export const generateWidgetId = (type: WidgetType): WidgetId =>
  `${type}-${Date.now()}-${Math.random().toString(36).substring(2, 9)}` as WidgetId;

/**
 * Extract base widget type from variant ID
 * e.g., 'geo-map-center' -> 'geo-map', 'statistics' -> 'statistics'
 */
export const extractBaseWidgetType = (id: string): WidgetType => {
  // Handle geo-map variants
  if (id.startsWith('geo-map')) {
    return 'geo-map' as WidgetType;
  }
  // For all other widgets, the id is already the widget type
  return id as WidgetType;
};

/**
 * Extract widget default settings from config
 */
export const extractWidgetDefaults = (_config: unknown) => ({});

/**
 * Format widget type name for display
 */
export const formatWidgetName = (widgetType: string): string =>
  widgetType.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
